<h1 mat-dialog-title *ngIf="object">{{ object.Title }}  @if(object.Alias != null){ - ({{object.Alias}})}</h1>
<div *ngIf="loader" class="componentLoader">
  <mat-progress-spinner diameter="25" mode="indeterminate"></mat-progress-spinner>
</div>
<div *ngIf="object && !loader" mat-dialog-content>
  <div class="container" style="background-color: transparent; border: 0">
    <div class="rounded-corners">
      <img src="{{object.Image}}" />
    </div>
    <div>
      <div *ngFor="let attribute of object.Type?.Attributes">
        <span class="info-title">{{ attribute.Name | translate:attribute.Key }}:</span>
        <span class="info-data">
          {{ attribute.Value }}@if(attribute.Unit){ {{ attribute.Unit | translate:'' }} }
        </span>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions *ngIf="true" class="trailer-info-button">
  <button mat-button mat-raised-button [mat-dialog-close]="true">OK</button>
</div>

